import { skipToken, useQuery } from "@tanstack/react-query"
import { fetchAuditRequestById } from "@/entities/audit-request/api/fetch-audit-request-by-id.ts"

export const useFetchAuditRequestById = (id?: string) => {
  return useQuery({
    queryKey: ["audit-requests", id],
    queryFn: id ? () => fetchAuditRequestById(id) : skipToken
  })
}
